import React, { useEffect } from 'react'
import { postSigningCompleteToParent } from '../../lib/utils/signing-complete'

export const CloseTabComponent = () => {
  useEffect(() => {
    const notifiedParent = postSigningCompleteToParent()
    if (notifiedParent) return

    const timer = setTimeout(() => {
      window.close()
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  const inIframe = typeof window !== 'undefined' && window.parent !== window

  return (
    <div data-testid='close-tab-component' className='p-24' style={{ textAlign: 'center' }}>
      <h2>Signing complete</h2>
      <p className='basic mt-12 default-gray regular'>
        {inIframe
          ? 'Confirming your signature…'
          : 'This tab will close automatically in a few seconds.'}
      </p>
    </div>
  )
}
